import type { FaireProductEntity } from "../../entity_types/product";

export const p_y3cz9zj6db: FaireProductEntity = {
  token: "p_y3cz9zj6db",
  type: "product",
  name: "Bohemian  Casual Dress",
  brandToken: "b_ysnwrcjujg",
  brandName: "Unknown Brand",
  imageUrl: "https://cdn.faire.com/fastly/6675e7767bf1044265dbe13288d805ffaa5812775905d5ca5a039170dab38693.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7474bd8951caefd774e63d7bce23f5eca792f7fae8641fd4fc8a883fb8160d81.jpeg",
    "https://cdn.faire.com/fastly/4d2310e6ed40087e52ff69eea439105b608975e76a8c3033441d96006b2c1d00.jpeg",
    "https://cdn.faire.com/fastly/62cbe12f8012acfd02d7009bb8de592c579676bd14e1742445b8d4783aac561a.jpeg"
  ],
  priceDollars: 24.92,
  description: "Your new bohemian dress features intricate details and an elegant flowing hem. Perfect for any occasion, effortlessly transitioning from a casual day out to a stylish night gathering.\n\nFabric: 100% polyester\n\nWeight: 0.77 lb\n",
  tags: [],
  msrpDollars: 49.83,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:45.478Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
